import React from "react";

import { MainWrapper } from "./components";
import PageOutline from "../../components/page-outline/PageOutline";

const Washington = () => {


  return (
    <PageOutline header={{ title: "News - Washington Post" }}>
      <MainWrapper>
      <iframe title="washingtonpost-iframe" src="https://www.washingtonpost.com" width="100%" height="100%" frameBorder="0" allowtransparency="false" allow="encrypted-media"></iframe>
      </MainWrapper>
    </PageOutline>
  );
};

export default Washington;
